import MultiSelectFilterOptions from './MultiSelectFilterOptions.component';

export default MultiSelectFilterOptions;
